var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReturnArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0006 6.33081C12.4516 6.33081 6.33203 12.4504 6.33203 19.9993C6.33203 27.5483 12.4516 33.6679 20.0006 33.6679C27.5495 33.6679 33.6691 27.5483 33.6691 19.9993C33.6691 12.4504 27.5495 6.33081 20.0006 6.33081ZM5.33203 19.9993C5.33203 11.8981 11.8994 5.33081 20.0006 5.33081C28.1018 5.33081 34.6691 11.8981 34.6691 19.9993C34.6691 28.1005 28.1018 34.6679 20.0006 34.6679C11.8994 34.6679 5.33203 28.1005 5.33203 19.9993ZM12.8218 19.6242C12.5944 19.8234 12.5944 20.1772 12.8218 20.3764L18.621 25.4564C18.8287 25.6384 18.8496 25.9543 18.6677 26.162C18.4857 26.3697 18.1698 26.3906 17.9621 26.2086L12.1629 21.1286C11.4807 20.5311 11.4807 19.4695 12.1629 18.872L17.9621 13.792C18.1698 13.61 18.4857 13.6309 18.6677 13.8386C18.8496 14.0464 18.8287 14.3622 18.621 14.5442L12.8218 19.6242ZM13.3959 19.5003C13.1198 19.5003 12.8959 19.7242 12.8959 20.0003C12.8959 20.2764 13.1198 20.5003 13.3959 20.5003H27.4958C27.7719 20.5003 27.9958 20.2764 27.9958 20.0003C27.9958 19.7242 27.7719 19.5003 27.4958 19.5003H13.3959Z",
    fill: "#6D6970"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnArrow);
export default __webpack_public_path__ + "static/media/return-arrow.9b6308ba6de2822b078478cb0db1963e.svg";
export { ForwardRef as ReactComponent };